import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { resources } from './resources'
import { Language } from '../types/language'

export const AVAILABLE_LANGS = Object.values(Language)

i18n.use(initReactI18next).init({
  lng: 'ro',
  fallbackLng: 'ro',
  resources,

  interpolation: {
    escapeValue: false,
  },
})

export default i18n
